var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-img',{attrs:{"id":"imageFeature","fluid":"","src":_vm.image_url},on:{"load":_vm.onImageLoad}}),_c('canvas',{staticClass:"canvas",attrs:{"id":"canvas"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }